"use client";

import { useLayoutEffect } from "react";
import { usePathname } from "next/navigation";

const ListingScrollReset = () => {
  const pathname = usePathname();

  useLayoutEffect(() => {
    const prev = history.scrollRestoration;
    history.scrollRestoration = "manual";
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    return () => {
      history.scrollRestoration = prev;
    };
  }, [pathname]);

  return null;
};

export default ListingScrollReset;
